"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_framework_utils_1 = require("@sky-uk-ott/client-lib-js-player-framework-utils");
function extractEncodedResponseData(response) {
    return client_lib_js_player_framework_utils_1.stringToUint(response.responseText);
}
exports.default = extractEncodedResponseData;
